import React from 'react';
import FramedPanel from '../../components/FramedPanel';

// Fraud Alerts hero (9-22 mockups): the "Identify. Understand. Avoid." line
// sits on the top border of a black frame with the SCAM photo inside - the
// same frame the Hot Scam and MoSAIC pages use.
const HeroBanner = () => (
  <FramedPanel title="Identify. Understand. Avoid.">
    <div className="px-6 pt-10 pb-6">
      <img
        src="/images/fraud-alerts/scam-hero.jpeg"
        alt="SCAM warning over money"
        className="w-full max-h-[300px] object-cover block"
      />
    </div>
  </FramedPanel>
);

export default HeroBanner;
